/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetDriverUpdateRecommendation: BridgeCommands.Command<
    {},
    Types.Gfe.Driverupdaterecommendation.GetDriverUpdateRecommendationReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverUpdateRecommendation',
    method: 'GetDriverUpdateRecommendation',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetUserDriverTypePreference: BridgeCommands.Command<
    {},
    Types.Gfe.Driverupdaterecommendation.GetUserDriverTypePreferenceReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverUpdateRecommendation',
    method: 'GetUserDriverTypePreference',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetUserDriverTypePreference: BridgeCommands.Command<
    Types.Gfe.Driverupdaterecommendation.SetUserDriverTypePreferenceParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverUpdateRecommendation',
    method: 'SetUserDriverTypePreference',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetAutomaticDriverDownloadEnabled: BridgeCommands.Command<
    {},
    Types.Gfe.Driverupdaterecommendation.GetAutomaticDriverDownloadEnabledReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverUpdateRecommendation',
    method: 'GetAutomaticDriverDownloadEnabled',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetAutomaticDriverDownloadEnabled: BridgeCommands.Command<
    Types.Gfe.Driverupdaterecommendation.SetAutomaticDriverDownloadEnabledParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverUpdateRecommendation',
    method: 'SetAutomaticDriverDownloadEnabled',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const StartDriverUpdateCheck: BridgeCommands.Command<
    {},
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverUpdateRecommendation',
    method: 'StartDriverUpdateCheck',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterDriverUpdateCheckProgressNotifications: BridgeCommands.Command<
    {},
    Types.Gfe.Driverupdaterecommendation.RegisterDriverUpdateCheckProgressNotificationsReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverUpdateRecommendation',
    method: 'RegisterDriverUpdateCheckProgressNotifications',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetGRDEditorPreviewMode: BridgeCommands.Command<
    {},
    Types.Gfe.Driverupdaterecommendation.GetGRDEditorPreviewModeReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverUpdateRecommendation',
    method: 'GetGRDEditorPreviewMode',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetDriverUpdateNotificationEnabled: BridgeCommands.Command<
    {},
    Types.Gfe.Driverupdaterecommendation.GetDriverUpdateNotificationEnabledReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverUpdateRecommendation',
    method: 'GetDriverUpdateNotificationEnabled',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetDriverUpdateNotificationEnabled: BridgeCommands.Command<
    Types.Gfe.Driverupdaterecommendation.SetDriverUpdateNotificationEnabledParameters,
    any
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'DriverUpdateRecommendation',
    method: 'SetDriverUpdateNotificationEnabled',
    persistent: false
};

export const Driverupdaterecommendation = {
GetDriverUpdateRecommendation,
GetUserDriverTypePreference,
SetUserDriverTypePreference,
GetAutomaticDriverDownloadEnabled,
SetAutomaticDriverDownloadEnabled,
StartDriverUpdateCheck,
RegisterDriverUpdateCheckProgressNotifications,
GetGRDEditorPreviewMode,
GetDriverUpdateNotificationEnabled,
SetDriverUpdateNotificationEnabled
};
